export const awareGoTheme = {
    primary: '#20A26B',
    secondary: '#CC213D',
};
